/**
 * Bilingual UI Dictionary (French & Arabic).
 */

export const TRANSLATIONS = Object.freeze({
  fr: {
    // Navigation
    home: 'Accueil',
    catalog: 'Catalogue',
    orderTracking: 'Suivi de commande',
    contact: 'Contact',
    admin: 'Administration',
    cart: 'Panier',

    // Top Bar & Hero
    announcement: 'Livraison gratuite partout au Maroc — Paiement à la réception',
    heroTitle: 'Équipez votre véhicule avec précision et fiabilité',
    heroSubtitle: 'Large gamme d’accessoires automobiles sélectionnés pour le marché marocain.',
    exploreCatalog: 'Découvrir le catalogue',
    quickSearch: 'Recherche rapide',

    // Catalog & Products
    allCategories: 'Toutes les catégories',
    inStockOnly: 'En stock uniquement',
    onSaleOnly: 'En promotion',
    sortBy: 'Trier par',
    sortNewest: 'Nouveautés',
    sortPriceAsc: 'Prix croissant',
    sortPriceDesc: 'Prix décroissant',
    viewProduct: 'Voir le produit',
    orderNow: 'Commander maintenant',
    outOfStock: 'Rupture de stock',
    inStock: 'En stock',
    freeDelivery: 'Livraison Gratuite',
    payOnDelivery: 'Paiement à la livraison',
    universalFit: 'Compatibilité universelle',
    specificFit: 'Compatibilité spécifique',
    noProductsFound: 'Aucun produit trouvé.',
    page: 'Page',
    of: 'sur',
    previous: 'Précédent',
    next: 'Suivant',

    // Product Detail
    reference: 'Réf.',
    selectColor: 'Choisissez une couleur',
    quantity: 'Quantité',
    compatibilityTitle: 'Compatibilité véhicule',
    serviceNotes: 'Paiement en espèces lors de la livraison après vérification du colis.',

    // Checkout & Order Form
    checkoutTitle: 'Finaliser ma commande express',
    customerInfo: 'Coordonnées du destinataire',
    fullNameLabel: 'Nom et Prénom',
    fullNamePlaceholder: 'ex: Mohamed Alami',
    phoneLabel: 'Numéro de téléphone mobile',
    phonePlaceholder: '06XXXXXXXX ou 07XXXXXXXX',
    cityLabel: 'Ville de livraison',
    cityPlaceholder: 'ex: Casablanca, Rabat, Marrakech...',
    districtLabel: 'Quartier / Secteur (facultatif)',
    districtPlaceholder: 'ex: Maarif, Agdal, Guéliz...',
    addressLabel: 'Adresse exacte de livraison',
    addressPlaceholder: 'Rue, N° d’immeuble, étage ou repère',
    instructionsLabel: 'Remarques ou instructions de livraison (facultatif)',
    instructionsPlaceholder: 'ex: Appeler avant 14h, livrer au bureau...',
    consentLabel: 'J’accepte d’être contacté(e) par appel et WhatsApp pour confirmer ma commande et recevoir les détails d’expédition.',
    submitOrder: 'Confirmer ma commande',
    submittingOrder: 'Validation de votre commande...',
    orderSummary: 'Récapitulatif de commande',
    subtotal: 'Sous-total',
    shipping: 'Livraison',
    totalToPay: 'Total à payer à la livraison',
    orderSuccessTitle: '🎉 Félicitations ! Votre commande a été enregistrée',
    orderNumberLabel: 'Numéro de commande :',
    trackingTokenNotice: 'Conservez précieusement ce lien et votre clé de suivi pour vérifier l’état de votre colis :',
    viewTrackingBtn: 'Suivre ma commande en direct →',
    orderAnotherBtn: 'Passer une autre commande',

    // Tracking Page
    trackTitle: 'Suivi de Commande en Temps Réel',
    trackSubtitle: 'Entrez votre numéro de commande et votre clé de suivi pour consulter l’état d’expédition.',
    trackingNumberInput: 'Numéro de commande',
    trackingTokenInput: 'Clé de suivi sécurisée',
    trackBtn: 'Consulter le suivi',
    trackingStatusLabel: 'Statut actuel :',
    orderDateLabel: 'Date de commande :',
    orderItemsTitle: 'Articles commandés',
    timelineTitle: 'Historique d’expédition',
    noTrackingData: 'Veuillez saisir votre numéro de commande et clé de suivi.',

    // Common
    loading: 'Chargement en cours...',
    retry: 'Réessayer',
    backToHome: 'Retour à l’accueil',
    pageNotFound: 'Page introuvable',
    pageNotFoundDesc: 'La page que vous recherchez n’existe pas ou a été déplacée.',
  },
  ar: {
    // Navigation
    home: 'الرئيسية',
    catalog: 'الكتالوج',
    orderTracking: 'تتبع الطلب',
    contact: 'اتصل بنا',
    admin: 'لوحة التحكم',
    cart: 'السلة',

    // Top Bar & Hero
    announcement: 'توصيل مجاني لجميع مدن المغرب — الدفع نقداً عند الاستلام',
    heroTitle: 'جهّز سيارتك بأفضل الإكسسوارات وقطع الغيار',
    heroSubtitle: 'تشكيلة واسعة من إكسسوارات السيارات المختارة بعناية للسوق المغربي.',
    exploreCatalog: 'تصفح الكتالوج',
    quickSearch: 'بحث سريع',

    // Catalog & Products
    allCategories: 'جميع الفئات',
    inStockOnly: 'المتوفر في المخزون فقط',
    onSaleOnly: 'العروض والتخفيضات',
    sortBy: 'ترتيب حسب',
    sortNewest: 'الأحدث',
    sortPriceAsc: 'السعر: من الأقل للأعلى',
    sortPriceDesc: 'السعر: من الأعلى للأقل',
    viewProduct: 'عرض المنتج',
    orderNow: 'اطلب الآن',
    outOfStock: 'نفد من المخزون',
    inStock: 'متوفر',
    freeDelivery: 'توصيل مجاني',
    payOnDelivery: 'الدفع عند الاستلام',
    universalFit: 'متوافق مع جميع السيارات',
    specificFit: 'توافق مخصص حسب الموديل',
    noProductsFound: 'لم يتم العثور على أي منتج.',
    page: 'صفحة',
    of: 'من',
    previous: 'السابق',
    next: 'التالي',

    // Product Detail
    reference: 'رمز المنتج',
    selectColor: 'اختر اللون',
    quantity: 'الكمية',
    compatibilityTitle: 'توافق السيارة',
    serviceNotes: 'الدفع نقداً عند الاستلام بعد معاينة المنتج.',

    // Checkout & Order Form
    checkoutTitle: 'إتمام الطلب السريع',
    customerInfo: 'معلومات المستلم',
    fullNameLabel: 'الاسم واللقب',
    fullNamePlaceholder: 'مثال: محمد العلمي',
    phoneLabel: 'رقم الهاتف المحمول',
    phonePlaceholder: '06XXXXXXXX أو 07XXXXXXXX',
    cityLabel: 'مدينة التوصيل',
    cityPlaceholder: 'مثال: الدار البيضاء، الرباط، مراكش...',
    districtLabel: 'الحي / المنطقة (اختياري)',
    districtPlaceholder: 'مثال: المعاريف، أكدال، جيليز...',
    addressLabel: 'عنوان التوصيل بالتفصيل',
    addressPlaceholder: 'الشارع، رقم العمارة، الطابق أو علامة مميزة',
    instructionsLabel: 'ملاحظات إضافية للموزع (اختياري)',
    instructionsPlaceholder: 'مثال: الاتصال قبل الساعة الثانية ظهراً...',
    consentLabel: 'أوافق على التواصل معي عبر الهاتف وواتساب لتأكيد الطلب وتتبع الشحنة.',
    submitOrder: 'تأكيد الطلب الآن',
    submittingOrder: 'جاري تأكيد وتسجيل طلبكم...',
    orderSummary: 'ملخص الطلب',
    subtotal: 'المجموع الجزئي',
    shipping: 'مصاريف التوصيل',
    totalToPay: 'المجموع الواجب دفعه عند الاستلام',
    orderSuccessTitle: '🎉 مبروك! تم تسجيل طلبكم بنجاح',
    orderNumberLabel: 'رقم الطلب الخاص بكم:',
    trackingTokenNotice: 'احتفظ بهذا الرابط ورمز التتبع لمتابعة حالة الشحنة في أي وقت:',
    viewTrackingBtn: 'تتبع طلبي مباشرة ←',
    orderAnotherBtn: 'طلب منتج آخر',

    // Tracking Page
    trackTitle: 'تتبع الطلب مباشرة',
    trackSubtitle: 'أدخل رقم الطلب ورمز التتبع الخاص بك لمعرفة حالة التوصيل.',
    trackingNumberInput: 'رقم الطلب',
    trackingTokenInput: 'رمز التتبع السري',
    trackBtn: 'عرض حالة الطلب',
    trackingStatusLabel: 'الحالة الحالية:',
    orderDateLabel: 'تاريخ الطلب:',
    orderItemsTitle: 'المنتجات المطلوبة',
    timelineTitle: 'مراحل الشحن والتوصيل',
    noTrackingData: 'يرجى إدخال رقم الطلب ورمز التتبع.',

    // Common
    loading: 'جاري التحميل...',
    retry: 'إعادة المحاولة',
    backToHome: 'العودة للرئيسية',
    pageNotFound: 'الصفحة غير موجودة',
    pageNotFoundDesc: 'الصفحة التي تبحث عنها غير متوفرة أو تم نقلها.',
  },
});
